export const typeRpc = [
  { id: 'future', name: 'Future' },
  { id: 'spot', name: 'Spot' },
  { id: 'meme', name: 'MEME' },
  { id: 'stock', name: 'Stock' },
  { id: 'trading', name: 'Trading' },
  { id: 'wss', name: 'Wss' },
  { id: 'rpc', name: 'Rpc' },
];
